import type { Me, TeamMember } from "../api/types";

interface Props {
  team: TeamMember[];
  me: Me;
  value: string | null;
  onChange: (userId: string | null) => void;
}

/** The "Viewing calendar for" selector. Only ever rendered for admins and sub-admins. */
export function PersonPicker({ team, me, value, onChange }: Props): JSX.Element {
  return (
    <div className="person-picker">
      <label>
        <span className="muted small">Viewing calendar for</span>
        <select
          value={value ?? me.id}
          onChange={(event) => {
            const selected = event.target.value;
            onChange(selected === me.id ? null : selected);
          }}
        >
          <option value={me.id}>{me.display_name} (you)</option>
          {team
            .filter((member) => member.id !== me.id)
            .map((member) => (
              <option key={member.id} value={member.id}>
                {member.display_name}
                {member.is_active ? "" : " — deactivated"}
              </option>
            ))}
        </select>
      </label>
    </div>
  );
}
